import React from "react";

const AuthTitleBar: React.FC = () => {
  // Don't render on web, only in Electron
  if (!window.electronAPI) return null;

  return (
    <div className="flex items-center justify-end h-10 bg-transparent px-2 select-none drag absolute top-0 right-0 z-50">
      <div className="flex items-center gap-1" style={{ WebkitAppRegion: 'no-drag' } as any}>
        <button
          type="button"
          onClick={() => window.electronAPI?.minimize()}
          className="flex h-8 w-10 items-center justify-center rounded-md text-gray-400 transition hover:bg-gray-700 hover:text-white"
          aria-label="Minimize window"
        >
          <svg className="h-3 w-3" viewBox="0 0 10 1" fill="currentColor" aria-hidden="true">
            <rect width="10" height="1" rx="0.5" />
          </svg>
        </button>
        <button
          type="button"
          onClick={() => window.electronAPI?.maximize()}
          className="flex h-8 w-10 items-center justify-center rounded-md text-gray-400 transition hover:bg-gray-700 hover:text-white"
          aria-label="Maximize window"
        >
          <svg className="h-3.5 w-3.5" viewBox="0 0 11 11" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
            <rect x="0.5" y="0.5" width="10" height="10" rx="1" />
          </svg>
        </button>
        <button
          type="button"
          onClick={() => window.electronAPI?.close()}
          className="flex h-8 w-10 items-center justify-center rounded-md text-gray-400 transition hover:bg-red-600 hover:text-white"
          aria-label="Close window"
        >
          <svg className="h-4 w-4" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true">
            <path d="M1 1l8 8M9 1L1 9" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AuthTitleBar;

